module.exports = __webpack_public_path__ + "static/media/pastevent5.ace48ea2.jpg";